/**
 * External Dependencies
 */
import 'jquery';
import 'jquery-drilldown';
import './blocks/projects-slider';
import './blocks/project-planning';
import './blocks/faq';
import './blocks/images-slider';
import './blocks/contacts-slider';
import './blocks/text-with-images-slider';
import './blocks/latest-new-slider';
import './blocks/text-slider-with-image';
import './blocks/open-vacancies';
import './blocks/vacancies-slider-block';
import './blocks/post-archive-block';
import './blocks/before-and-after-slider-block';
import { initMap, centerMap } from './projects-map';
import { applyFormFixes } from './form-fixes';

require('./navigation');
require('./modal');

$(() => {

    // Applies the wpForms plugin css style fixes.
    applyFormFixes();
    let naviContainer = $('.navigation-container');
    let lastScrollTop = 0;

  /**
   * Hides main menu on scrolling.
   */
    window.addEventListener('scroll', () => {

        let wpAdminBar = document.getElementById('wpadminbar');
        let navHeight = naviContainer.height();
        let doc = document.documentElement;
        let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

        if (wpAdminBar) {
            let top = top + wpAdminBar.clientHeight;
        }

        if (top > lastScrollTop) {
            if (top >= (navHeight)) {
                naviContainer.addClass("scrollUp");
            } else {
                naviContainer.removeClass("scrollUp");
            }
        } else {
            naviContainer.removeClass("scrollUp");
        }

        lastScrollTop = top <= 0 ? 0 : top;

    }, true)

  // Initialize map when it can find an acf-map
  let map = initMap($('.acf-map'));
  let headermap = initMap($('.header-acf-map'), true);

  window.addEventListener('resize', () => {
        if (headermap) {
            centerMap(headermap);
        }
        if (map) {
            centerMap(map);
        }
    });

if (headermap) {
    centerMap(headermap);
}

  // Switches tabs on the project archive page
  $('.project-archive-switcher .show-map').click(function () {
    $('.project-archive-switcher .show-list').removeClass('active bg-ntp-yellow')
    $('.project-archive-switcher .show-list').addClass('bg-ntp-beige-dark')
    $(this).addClass('active bg-ntp-yellow');
    $(this).removeClass('bg-ntp-beige-dark');
    $('.projects-map-tab').removeClass('hidden');
    $('.projects-list-tab').addClass('hidden');

    // Center the map on switching.
    if (map) {
        centerMap(map);
    }
  })

  $('.project-archive-switcher .show-list').click(function () {
    $('.project-archive-switcher .show-map').removeClass('active bg-ntp-yellow')
    $('.project-archive-switcher .show-map').addClass('bg-ntp-beige-dark')
    $(this).addClass('active bg-ntp-yellow');
    $(this).removeClass('bg-ntp-beige-dark');
    $('.projects-map-tab').addClass('hidden');
    $('.projects-list-tab').removeClass('hidden');
  });
  const urlSearchParams = new URLSearchParams(window.location.search);

  let projectStatus = urlSearchParams.get('status');
if (projectStatus) {
    $(".project-status-filter").val(projectStatus);
}
  $(".project-status-filter").change(function (e) {

    let optionAttr = $('option:selected', this).attr('data-attr');

    // Resets the current url on clearable selected.
    if (typeof optionAttr !== 'undefined' && optionAttr === 'clearable') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.delete('status')
        window.location.replace('?' + urlSearchParams.toString());
    }

    if (optionAttr !== 'clearable') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.set('status', e.target.value)
        window.location.replace('?' + urlSearchParams.toString());
    }

  });

  let projectCategory = urlSearchParams.get('category');
if (projectCategory) {
    $(".project-category-filter").val(projectCategory);
}
  $("select.project-category-filter").change(function (e) {

    let optionAttr = $('option:selected', this).attr('data-attr');

    // Resets the current url on clearable selected.
    if (typeof optionAttr !== 'undefined' && optionAttr === 'clearable') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.delete('category')
        window.location.replace('?' + urlSearchParams.toString());
    }

    if (optionAttr !== 'clearable') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.set('category', e.target.value)
        window.location.replace('?' + urlSearchParams.toString());
    }

  });

  let projectSearch = urlSearchParams.get('location_search');
if (projectSearch) {
    $(".project-search-input").val(projectSearch);
}

  $('.project-search-input').keyup(function (event) {
    if (event.keyCode === 13) {
      // Resets the current url on clearable selected.
        if (!$(this).val() && $(this).val() === "") {
            const urlSearchParams = new URLSearchParams(window.location.search);
            urlSearchParams.delete('location_search')
            window.location.replace('?' + urlSearchParams.toString());
        }

        if ($(this).val()) {
            const urlSearchParams = new URLSearchParams(window.location.search);
            urlSearchParams.set('location_search', $(this).val())
            window.location.replace('?' + urlSearchParams.toString());
        }
    }
  });

  const urlSearchParamss = new URLSearchParams(window.location.search);
  let post_type = urlSearchParamss.get('post_type');
  if (post_type === 'projecten') {
    $("input[value='projecten']").prop('checked', true);
  }

  if (post_type === 'nieuws') {
    $("input[value='nieuws']").prop('checked', true);
  }

  if (post_type === 'verhalen') {
    $("input[value='verhalen']").prop('checked', true);
  }

  $('.search-form').on('keypress',function(e) {
    if(e.which == 13) {
      let searchTerms = $('.search-input').val();
      let selectedPostType = $('.search-form').find('input[type=radio]:checked').val();

      const urlSearchParams = new URLSearchParams(window.location.search);
      urlSearchParams.set('s', searchTerms)
      if (selectedPostType === 'none') {
        urlSearchParams.delete('post_type')
      } else {
        urlSearchParams.set('post_type', selectedPostType)
      }
      window.location.replace(window.location.origin + '?' + urlSearchParams.toString());
    }
  });

  $('.search-form').find('.wpforms-submit').click(function () {
    let searchTerms = $('.search-input').val();
    let selectedPostType = $('.search-form').find('input[type=radio]:checked').val();

    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set('s', searchTerms)

    if (selectedPostType === 'none') {
      urlSearchParams.delete('post_type')
    } else {
      urlSearchParams.set('post_type', selectedPostType)
    }

    window.location.replace(window.location.origin + '?' + urlSearchParams.toString());
  })


  $(function() {
    fadingDivs();
  });

  $(window).on("scroll" , function() {
    fadingDivs();
  });

  function fadingDivs() {
    $(".fadethis").each(function(index) {
      /*additional for better visibilty of the effect */
      var $this = $(this);
      var bgColor = $this.text();
      $this.css('background-color', bgColor);
      $this.css('color', bgColor);

      var top_of_element = $this.offset().top;
      var bottom_of_element = top_of_element + $this.outerHeight();
      var bottom_of_screen = $(window).scrollTop() + window.innerHeight;
      var top_of_screen = $(window).scrollTop();

      if((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        $this.addClass("inview");
      }

    });
  }
});

